import React from "react";
import { Upload, Button, message } from "antd";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import OssUtils from "../../../util/oss-utils";

export default function UploadFile({
    value = [],
    onChange,
    maxCount,
    size,
    accept,
    className,
    fileKey,
    action,
    listType,
    disabled,
    onlyPreview,
    showUploadList,
    onPreview,
    uploadButton,
    uploadPrefix = "",
}) {
    const picUploadButton = (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8, color: "rgba(0, 0, 0, 0.65)" }}>上传</div>
        </div>
    );
    const textUploadButton = (
        <Button icon={<UploadOutlined />} disabled={disabled}>
            上传
        </Button>
    );
    const getExtraData = file => {
        return {
            key: file.key,
            success_action_status: "200",
            policy: file.policy,
            "x-oss-signature": file.signature,
            "x-oss-signature-version": file.version,
            "x-oss-credential": file.xOssCredential,
            "x-oss-date": file.xOssDate,
            "x-oss-security-token": file.securityToken,
        };
    };
    const beforeUpload = (file, fileList) => {
        let suffix = file.name.split(".").reverse()[0].toLocaleLowerCase();
        if (accept && accept.length > 0 && !accept.includes(suffix)) {
            message.error(`对不起，只支持类型为${accept}的文件`);
            return Upload.LIST_IGNORE;
        }
        if (size && file.size / 1024 / 1024 > size) {
            message.error(`对不起，文件大小不能超过${size}M`);
            return Upload.LIST_IGNORE;
        }
        return new Promise(async (resolve, reject) => {
            try {
                // 生成key，支持前缀
                let key;
                if (uploadPrefix) {
                    key = OssUtils.generateOssKeyWithNumber(file.name, uploadPrefix);
                } else if (fileKey) {
                    key = OssUtils.generateOssKeyWithNumber(file.name, fileKey);
                } else {
                    key = OssUtils.generateOssKeyWithNumber(file.name);
                }

                // 获取OSS签名
                const signatureData = await OssUtils.getOssSignature({
                    bucket: "dante-img",
                    region: "cn-hangzhou",
                    maxFileSize: file.size || 10485760, // 10MB
                    uploadDir: key,
                });

                const uploadUrl = OssUtils.processUploadUrl(signatureData.host);

                // 为文件对象添加签名信息
                OssUtils.attachSignatureToFile(file, signatureData, key, uploadUrl);
                file.url = `${uploadUrl}/${key}`;

                resolve(file);
            } catch (error) {
                message.error("获取上传签名失败，请重试");
                console.error("Get signature error:", error);
                reject(error);
            }
        });
    };

    const triggerChange = changedValue => {
        onChange?.([...changedValue]);
    };
    const handleChange = ({ fileList }) => {
        triggerChange(fileList);
    };
    return (
        <Upload
            disabled={disabled}
            accept={accept}
            maxCount={maxCount}
            onPreview={onPreview}
            showUploadList={showUploadList}
            listType={listType || "picture-card"}
            beforeUpload={beforeUpload}
            className={className}
            action={file => file.uploadUrl || action || "//dante-img.oss-cn-hangzhou.aliyuncs.com"}
            data={getExtraData}
            onChange={handleChange}
            fileList={value || []}>
            {!onlyPreview &&
                (value.length >= maxCount
                    ? null
                    : uploadButton || (listType === "picture-card" ? picUploadButton : textUploadButton))}
        </Upload>
    );
}
